import { Component, OnInit } from "@angular/core";
import { initChartDefaults } from "./utils/chart-config";
import { VersionCheckService } from "../services/version-check.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  title = "parkbot-web";

  constructor(private versionCheckService: VersionCheckService) { }

  ngOnInit() {
    // Initialize Chart.js defaults
    initChartDefaults();

    // Initialize version checking for app updates
    this.versionCheckService.initVersionCheck();
  }
}
